export default "__VITE_ASSET__BEGXcpMx__"